import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  dailyPageErrorImage: {
    height: Theme.px(201),
    width: Theme.px(307),
  },
  dailyPageErrorText: {
    paddingLeft: Theme.px(87),
    width: Theme.px(525),
  },
  dailyPageErrorWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: Theme.px(150),
    width: '100%',
  },
  dayDetailDivider: {
    backgroundColor: Theme.whisperWhite,
    opacity: 1,
    width: Theme.px(2),
  },
  dayDetailTile: {
    backgroundColor: Theme.white,
    borderRadius: Theme.tileBorderRadius,
    height: Theme.px(278),
    letterSpacing: Theme.px(0),
    opacity: 0.05,
    width: Theme.px(802),
  },
  middleRowWrapper: {
    bottom: Theme.px(30),
    marginLeft: Theme.px(90),
    marginRight: Theme.px(120),
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  topRowWrapper: {
    bottom: Theme.px(65),
    justifyContent: 'flex-start',
    marginLeft: Theme.px(90),
    marginRight: Theme.px(90),
    marginTop: Theme.px(110),
  },
  wrapper: {
    paddingTop: Theme.px(61),
  },
});
